<template>
  <div
    :class="$style.root"
  >
    <i18nLink
      v-if="attributes?.slug"
      :to="{ name: 'journals-slug', params: { slug: attributes?.slug } }"
      :locale="i18nCode"
      :class="$style.link"
    >
      <CoreImageComponent
        v-if="attributes?.coverImage?.data?.attributes"
        :image="attributes?.coverImage?.data?.attributes"
        :class="$style.coverImage"
        :showCaption="false"
        :data-orientation="getOrientation(attributes?.coverImage?.data?.attributes)"
      />

      <div :class="$style.information">
        <div :class="$style.title">
          {{ title }}
        </div>
        <div
          v-if="tags || attributes?.highlighted"
          :class="$style.tags"
        >
          <template v-for="(tag, index) in tags" :key="index"> <span :class="$style.tag">{{ tag?.trim() }}</span>&nbsp;</template>
          <span
            v-if="attributes?.highlighted"
            :class="$style.tag"
          >
            {{ $t('shared.highlight') }}
          </span>
        </div>

        <div
          v-if="firstParagraph && !attributes?.coverImage?.data?.attributes"
          v-html="firstParagraph"
          :class="$style.firstParagraph"
        />

        <div
          v-if="attributes?.datePosted"
          :class="$style.updatedAt"
        >
          {{ $t('shared.datePosted') }}:
          <CoreDateTimeRangeComponent
            :dateStart="attributes?.datePosted"
            format="D MMMM YYYY"
          />
        </div>
      </div>

    </i18nLink>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps({
    data: Object
  })

  const localizedData = baseStrapiGetLocalizedData(props.data)

  const attributes = baseStrapiGetAttributes(localizedData)
  const i18nCode = baseI18nGetCodeForIso(attributes?.locale)
  const firstParagraph = baseStrapiGetFirstParagraphFromBlocks(attributes?.blocks)

  const tags = attributes?.journalTags?.data?.map(i => i?.attributes?.label)?.filter(Boolean)

  // NOTE extract to base, make part of component, also add square
  const getOrientation = (image) => {
    if (image?.width && image?.height) {
      return image.width > image.height ? 'landscape' : 'portrait'
    }
  }


  const title = baseTruncateString(attributes?.title, 12)

</script>

<style module>
  .root {
  }

  .link {
    composes: reset-link from global;
  }

  .information {
  }

  .title {
    composes: font-size-large from global;
  }

  .link:hover .title {
    text-decoration-line: underline;
  }

  .coverImage {
    --base--image--object-fit: contain;
    --base--image--object-position: center;

    display: flex;
    justify-content: center;

    margin-bottom: calc(var(--unit--vertical) / 2);
  }

  .coverImage img {
  }

  .coverImage[data-orientation='portrait'] {
    --base--image--object-fit: cover;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }

  .firstParagraph {
    composes: font-size-medium from global;
    margin-top: calc(var(--unit--vertical) / 2);
    margin-bottom: calc(var(--unit--vertical) / 2);
  }

  .firstParagraph * {
    font-weight: normal;
    margin: 0;
  }

  .updatedAt {
    composes: font-helvetica font-size-small from global;
  }

  .tags {
  }

  .tag {
    composes: font-size-small font-helvetica label-inverted from global;
  }
</style>
